import React, { FC, useEffect, useState } from 'react';
import { Box, Button, IconButton } from '@material-ui/core';
import { ListAlt } from '@material-ui/icons';

import { Dialog } from '@app/components/common/modals';
import { FieldView } from '@app/components/common';
import { api } from '@app/api';

import { Bank, NewOutlet } from '../../../api/models/outlet';
interface DetailViewModalProps {
  outlet: NewOutlet;
}

const DetailViewModal: FC<DetailViewModalProps> = (props) => {
  const { outlet } = props;
  const [open, setOpen] = useState(false);
  const [bank, setBank] = useState<Bank>();

  useEffect(() => {
    if (!open || !outlet?.bic) {
      return;
    }
    (async () => {
      const { data: response } = await api.autocomplete.get({
        name: 'bank',
        search: '' + outlet?.bic,
      });
      if (response.code === 200) {
        setBank(response.data[0] as Bank);
      }
    })();
  }, [open, outlet?.bic]);

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <ListAlt />
      </IconButton>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        title={outlet.name}
        actions={<Button onClick={() => setOpen(false)}>Ок</Button>}
      >
        <Box minWidth="300px">
          <FieldView
            title="ИНН"
            value={outlet?.inn?.toString()?.padStart(12, '0') || 'отсутствует'}
            canCopy
            direction="row"
            captionVariant="h6"
            fullWidth
          />
          <FieldView
            title="КПП"
            value={outlet?.kpp?.toString() || 'отсутствует'}
            canCopy
            direction="row"
            captionVariant="h6"
            fullWidth
          />
          <FieldView
            title="ОКПО"
            value={outlet?.okpo?.toString() || 'отсутствует'}
            canCopy
            direction="row"
            captionVariant="h6"
            fullWidth
          />
          <FieldView
            title="БИК Банка"
            value={outlet?.bic?.toString()?.padStart(9, '0') || 'отсутствует'}
            canCopy
            direction="row"
            captionVariant="h6"
            fullWidth
          />
          <FieldView
            title="Банк"
            value={bank?.name || 'отсутствует'}
            direction="row"
            captionVariant="h6"
            fullWidth
          />
          <FieldView
            title="Корр. счет"
            value={
              outlet?.corr_account?.toString()?.padStart(20, '0') ||
              'отсутствует'
            }
            canCopy
            direction="row"
            captionVariant="h6"
            fullWidth
          />
          <FieldView
            title="Р. счет"
            value={
              outlet?.account?.toString()?.padStart(20, '0') || 'отсутствует'
            }
            canCopy
            direction="row"
            captionVariant="h6"
            fullWidth
          />
        </Box>
      </Dialog>
    </>
  );
};

export default DetailViewModal;
